module.exports = __webpack_public_path__ + "static/media/syringe.2182e20c.svg";